import { Tool } from '@app/shared/utils';
import { createSelector } from '@ngrx/store';
import { PetState } from './pet.state';
import { AppState } from '..';

const petState = (state: AppState) => state.pet;

export const selectRenalConsultationsWithoutVisit = createSelector(petState, (state: PetState) =>
  state.consultationsWithoutVisit.filter((item) => item.tool === Tool.RenalDetect),
);
export const selectGrowthChartData = createSelector(petState, (state: PetState) => state.growthChartData);
